import * as React from 'react';
import { QuestionClusterDto } from '../../../pages/questionClusterTypes';
import { StyleRulesCallback, WithStyles } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { QuestionDto } from '../../../pages/questionTypes';
import { Divider } from '@material-ui/core';
import { AnsweredCatalogueDto } from '../../../pages/answeredCatalogueTypes';
import { AnswerDto } from '../../../pages/answerTypes';
import { observer } from 'mobx-react';
import Question from './Question';
import Cluster from '../common/Cluster';
import { sortAsc } from '../../../util/sorting';

interface Props {
  questionCluster: QuestionClusterDto,
  answeredCatalogueDto: AnsweredCatalogueDto,
  updateAnsweredCatalogue: (updatedCatalogue: AnsweredCatalogueDto) => void
}

type LocalStyles = 'divider';

const localStyles: StyleRulesCallback<LocalStyles> = theme => ({
  divider: {
    margin: theme.spacing.unit
  },
});

type PropsWithStyle = WithStyles<LocalStyles> & Props;

@observer
class QuestionCluster extends React.Component<PropsWithStyle> {

  constructor(props: PropsWithStyle) {
    super(props);
    this.renderQuestions = this.renderQuestions.bind(this);
  }

  public render() {
    return (
      <Cluster
        cluster={this.props.questionCluster}
        renderQuestions={this.renderQuestions}/>

    )
  }

  private renderQuestions() {
    return (
      <>
        {
          this.props.questionCluster.questions
            .slice()
            .sort((q1, q2) => sortAsc(q1, q2))
            .map((question, index) => (
              this.renderQuestion(question, index)
            )
          )
        }
      </>
    )
  }

  private renderQuestion(question: QuestionDto, indexOfQuestion: number) {
    const lastQuestion = indexOfQuestion === this.props.questionCluster.questions.length - 1;
    return (
      <div key={question.id + 'container'}>
        <Question key={question.id} catalogueId={this.props.answeredCatalogueDto.id} question={question}
                  updateAnsweredCatalogue={this.props.updateAnsweredCatalogue}
                  existingAnswer={this.getAnswerIfExists(question)}/>
        {
          !lastQuestion &&
          <Divider key={question.id + 'devider'} className={this.props.classes.divider}/>
        }
      </div>
    )
  }

  private getAnswerIfExists(question: QuestionDto): AnswerDto | undefined {
    return this.props.answeredCatalogueDto.answers.find(answer => {
      return answer.question.id === question.id
    })
  }

}

export default withStyles(localStyles)(QuestionCluster);

